<p-card styleClass="p-3 very-compact-card mb-3">
  <p-steps
    [model]="steps"
    [activeIndex]="activeIndexStep"></p-steps>
</p-card>

<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <ng-container *ngIf="!activeIndexStep">
            <div class="field">
              <label class="font-medium required-field">Email</label>
              <crm-input-text
                [(value)]="email.email"
                [isError]="$any(errorEmail?.email)"></crm-input-text>
              <small
                *ngIf="errorEmail?.email"
                class="p-error">
                {{ errorEmail?.email | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 1">
            <div class="field">
              <label class="font-medium required-field">ФИО</label>
              <crm-input-text
                [(value)]="profileRegister.name"
                [isError]="$any(errorProfileRegister?.name)"></crm-input-text>
              <small
                *ngIf="errorProfileRegister?.name"
                class="p-error">
                {{ errorProfileRegister?.name | join }}
              </small>
            </div>
          </ng-container>

          <ng-container *ngIf="activeIndexStep === 2">
            <div class="field">
              <label class="font-medium required-field">Клиент</label>
              <crm-client-auto-complete
                [(selectedClient)]="user.client"
                [isError]="$any(errors?.client)"
                [customSearch]="false"
                [showClear]="true"
                appendTo="body"></crm-client-auto-complete>
              <small
                *ngIf="errors?.client"
                class="p-error">
                {{ errors.client | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Должность</label>
              <crm-input-text
                [(value)]="user.job"
                [isError]="$any(errors?.job)"></crm-input-text>
              <small
                *ngIf="errors?.job"
                class="p-error">
                {{ errors.job | join }}
              </small>
            </div>

            <div class="field">
              <label class="font-medium">Контрагент</label>
              <crm-contragent-multi-select
                [contragents]="contragents"
                [clientId]="user.client?.id"
                [(selectedContragents)]="user.contragents"
                [isError]="$any(errors?.client)"
                [customSearch]="!!contragents?.length"
                appendTo="body"></crm-contragent-multi-select>
              <small
                *ngIf="errors?.contragents"
                class="p-error">
                {{ errors.contragents | join }}
              </small>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                [(ngModel)]="user.isMailingEnabled"
                [binary]="true"
                inputId="isMailingEnabled"></p-checkbox>
              <label [for]="'isMailingEnabled'">Включить в рассылку</label>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                [(ngModel)]="user.invite"
                [binary]="true"
                inputId="invite"></p-checkbox>
              <label [for]="'invite'">Доступ в личный кабинет</label>
            </div>
          </ng-container>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <button
      pButton
      [label]="activeIndexStep === 2 ? 'Добавить' : 'Далее'"
      class="p-button-success mr-2"
      (click)="saveUser()"></button>

    <button
      *ngIf="activeIndexStep"
      pButton
      icon="pi pi-arrow-left"
      label="Назад"
      class="p-button-text p-button-secondary"
      (click)="back()"></button>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
